import { render, staticRenderFns } from "./choice_intention.vue?vue&type=template&id=3c8cd99e&"
import script from "./choice_intention.vue?vue&type=script&lang=js&"
export * from "./choice_intention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports